<template>
  <div style="padding-top: 10px" v-bind="footer.bind">
    <ContentExpand v-if="footer.render" :render="footer.render"></ContentExpand>
    <Page
      v-if="$page.isMethodDefault(footer.show, null, true)"
      :page-size-opts="footer.pageSize || pageConfig.pageSize"
      :total="pageConfig.total"
      show-sizer
      :page-size="footer.pageSize ? footer.pageSize[0] : pageConfig.size"
      @on-page-size-change="changeSize"
      @on-change="changePage"
      show-elevator
      show-total
      :current.sync="pageConfig.page"
    />
  </div>
</template>

<script>
import ContentExpand from "./expand";
export default {
  props: ["pageConfig", "footer"],
  inject: ["$page"],
  components: {
    ContentExpand,
  },
  methods: {
    changeSize(val) {
      this.$emit("changeSize");
      this.pageConfig.page = 1;
      this.pageConfig.size = val;
      this.$emit("getList");
    },
    changePage(val) {
      this.$emit("changePage");
      this.pageConfig.current = val;
      this.$emit("getList");
    },
  },
};
</script>

<style lang="scss" scoped></style>
